// Add your custom JS here.

import { initMacrothemesSwitcher } from './modules/macrothemes-switcher.js';
import { initCardSlider } from './modules/init-card-slider.js';
import StickyNavbar from './modules/sticky-navbar.js';

document.addEventListener('DOMContentLoaded', () => {
    initMacrothemesSwitcher();
    initCardSlider();
    StickyNavbar.initialize('mainNavbarWrapper');
});
